import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const RosterAPI = {
	list: async (params) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			params,
		});

		return response.data;
	},
	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Rosters",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Rosters/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Rosters/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getPlayers: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters/" + id + "/players",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	addPlayers: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Rosters/players",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deletePlayer: async (id, playerId) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Rosters/" + id + "/players/" + playerId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getStaffs: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Rosters/" + id + "/staff",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	addStaffs: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Rosters/staff",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteStaff: async (id, staffId) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Rosters/" + id + "/staff/" + staffId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
};
